import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import TerritoryDetails from './components/TerritoryDetails';
import { Tooltip } from '@mui/material';
import TerritoryModal from '../AddOrUpdate/components/TerritoryModal';
import EditIcon from '@mui/icons-material/Edit';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import PreviewIcon from '@mui/icons-material/Preview';
import { Redirect } from 'react-router-dom';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const TerritoryDetailsIndex = () => {
  useEffect(() => {
    getAllTerritoryDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isViewAreaPopup, setViewAreaPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllTerritoryDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllTerritoryDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
        console.error('response:', response);
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`,
        );
        return;

      }
    } catch (error) {
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 2,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Territory Name',
        accessor: 'regionName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Territory Code',
        accessor: 'regionCode',
        disableGlobalFilter: false,
      },

      

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
         
          <div className="icon-style"  style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Tooltip title="Click here to edit Territory Details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
            </Tooltip>
            <Tooltip title="Click here to view the Areas">
            <PreviewIcon style={{ cursor: "pointer" }} onClick={() => view(row.row.original)} />
          </Tooltip>
          </div>
        
       
        ),
      },
    ],
    [],
  );

  const edit = async (event) => {
    if (event.regionId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Territory Details")
    }
  }
  const view = async (event) => {
    if (event.regionId) {
      setTempData(event);
      setViewAreaPopup(true);
    }
  }
  if (isViewAreaPopup) {
    return <Redirect to={`/web_app/pnd_territory/region-list/${temp.regionId}`} />;
  }

  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <TerritoryDetails reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <TerritoryDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}

      {viewDetailPopup &&
        <TerritoryModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
        />}
    </Container>
  );
};

export default TerritoryDetailsIndex;